if (!customElements.get('form-validation')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
    }

    toggleErrorMessage(input, field) {
      const errorMessageSpan = field.querySelector(
        '.js-error-message'
      );

      if (!errorMessageSpan) return;

      errorMessageSpan.parentElement.classList.toggle(
        'hidden',
        input.validity.valid
      );
      errorMessageSpan.parentElement.classList.toggle(
        'has-error',
        !input.validity.valid
      );

      errorMessageSpan.innerHTML = input.type == 'email' ? window.validationStrings.invalidEmail : input.validationMessage;
    }

    setFieldValidity(input) {
      input.setAttribute('aria-invalid', !input.validity.valid);
      const field = input.closest('.js-field-wrapper');
      if (!field) return;
      field.classList.toggle('has-error', !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    handleSubmit(event) {
      event.preventDefault();
      const isValid = this.form.reportValidity();
      if (isValid) this.form.submit();
    }

    setEventHandlers() {
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        input.addEventListener('invalid', event => {
          event.preventDefault();
          this.setFieldValidity(input);
        });

        input.addEventListener('input', () => {
          input.dataset.dirty = 'true';
          this.setFieldValidity(input);
        });

        // Skip until edited, so server-rendered errors survive autofocus + blur
        ['blur', 'change'].forEach(eventName => {
          input.addEventListener(eventName, () => {
            if (!input.dataset.dirty) return;
            this.setFieldValidity(input);
          });
        });
      }
    }

    // Shopify renders the success message in every customer form on the page,
    // so keep it only in the form whose id matches the redirect hash
    scopeSuccessMessage() {
      const params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') !== 'true') return;

      const message = this.querySelector('.field__message');
      if (!message) return;

      if (window.location.hash === `#${this.form.id}`) {
        message.focus();
        return;
      }

      message.removeAttribute('autofocus');
      message.classList.add('hidden');
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener(
        'submit',
        this.handleSubmit.bind(this)
      );

      this.setEventHandlers();

      if (this.hasAttribute('data-scope-success')) this.scopeSuccessMessage();
    }
  }

  customElements.define('form-validation', FormValidation);
}
